import React, { useState } from 'react';
import Modal from 'components/shared/modals/Modal'
import { ReactComponent as IconShare } from 'images/share.svg';
import { ReactComponent as IconReport } from 'images/icons/report.svg';

import ReportModal from 'components/shared/modals/ReportModal';
import InfoModal from 'modules/feed/components/Feed/InfoModal';
import ShareModal from 'modules/feed/components/Feed/ShareModal';
import s from './AdditionalModal.module.scss';

type Props = {
  isOpen: boolean
  onClose: () => void
  setIsShowAdditionalModal: React.Dispatch<React.SetStateAction<boolean>>
}

function AdditionalModal({
  isOpen,
  onClose,
  setIsShowAdditionalModal,
}: Props) {
  const [isInfoModal, setIsInfoModal] = useState(false)
  const [isReportModal, setIsReportModal] = useState(false)
  const [isShareModal, setIsShareModal] = useState(false)

  const handleCloseInfoModal = () => {
    setIsInfoModal(false)
    setIsShowAdditionalModal(true)
  }

  const handleOpenReportModal = () => {
    setIsReportModal(true)
    onClose()
  }

  const handleCloseReportModal = () => {
    setIsReportModal(false)
    setIsShowAdditionalModal(true)
  }

  const handleOpenShareModal = () => {
    setIsShareModal(true)
    onClose()
  }

  const handleCloseShareModal = () => {
    setIsShareModal(false)
    setIsShowAdditionalModal(false)
  }

  return (
    <>
      <Modal
        onClose={onClose}
        isOpen={isOpen}
        onClick={(e: any) => e.stopPropagation()}
      >
        <div className={s.container}>
          <h2 className={s.title}>Additional</h2>
          <div className={s.innerBody}>
            <div className={s.secondRow}>
              <div className={s.secondaryBtnBlock} onClick={handleOpenShareModal}>
                <IconShare />
                <span>Share</span>
              </div>
              <div className={s.divider} />
              <div className={s.secondaryBtnBlock} onClick={handleOpenReportModal}>
                <IconReport />
                <span>Report</span>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      <InfoModal
        isOpen={isInfoModal}
        onClose={handleCloseInfoModal}
      />
      <ReportModal
        id="report"
        type="post"
        isOpen={isReportModal}
        onClose={() => {
          handleOpenReportModal()
          handleCloseReportModal()
          onClose()
        }}
        onBack={() => {
          handleOpenReportModal()
          handleCloseReportModal()
        }}
      />
      <ShareModal
        isOpen={isShareModal}
        onClose={handleCloseShareModal}
        handleOpenReportModal={handleOpenReportModal}
      />
    </>
  )
}

export default AdditionalModal
